import { Profile } from '@/types';

interface UserLike {
  email?: string;
}

export const PROFILE_UPDATED_EVENT = 'cai:profile-updated';

export function getEmailPrefix(email?: string): string {
  if (!email) return '';
  return email.split('@')[0] || '';
}

export function getDisplayName(profile?: Profile | null, user?: UserLike | null): string {
  const profileName = profile?.name?.trim();
  if (profileName) return profileName;

  const emailPrefix = getEmailPrefix(user?.email);
  if (emailPrefix) return emailPrefix;

  return 'Usuário';
}
